// extracted by mini-css-extract-plugin
export default {"reservedRights":"footer_reservedRights__eKtIb"};